var React = require('react');

function ToggleInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M5.33317 9.33335L7.99984 6.66669L10.6665 9.33335","stroke":"currentColor","strokeWidth":"1.5","strokeLinecap":"square"}));
}

ToggleInline.defaultProps = {"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none"};

module.exports = ToggleInline;

ToggleInline.default = ToggleInline;
